import './index.css';

import { useMemo } from 'react';
import slug from 'slug';

import { richTextToString } from '@/helpers/storyblok/rich-text';

import { SummaryClient } from './index.client';

export const formatAnchorId = (string) => {
  return typeof string === 'string' ? slug(string) : undefined;
};

const generateSummary = (body) => {
  const summary = [];

  body?.content?.forEach?.((item) => {
    if (item.type === 'heading') {
      if (item.attrs.level === 2) {
        summary.push({
          title: richTextToString(item),
          sub: [],
        });
      }
      // else if (item.attrs.level === 3 && summary[summary.length - 1]) {
      //   summary[summary.length - 1].sub.push({
      //     title: richTextToString(item),
      //   });
      // }
    }
  });

  return summary;
};

export const Summary = ({ body }) => {
  const summary = useMemo(() => {
    return generateSummary(body);
  }, [body]);

  return summary?.length > 0 ? <SummaryClient summary={summary} /> : null;
};
